import Vue from 'vue'
import { extend, configure } from 'vee-validate'
import {
    required,
    email,
    numeric,
    min,
    max,
    regex,
    length,
    confirmed,
} from 'vee-validate/dist/rules'

configure({
    defaultMessage: (field, values) => {
        // override the field name
        values._field_ = Vue.prototype._i18n.t(`fields.${field}`)
        return Vue.prototype._i18n.t(`validation.${values._rule_}`, values)
    },
})

// Add the required rule
extend('required', required)
extend('email', email)
extend('numeric', numeric)
extend('min', min)
extend('max', max)
extend('regex', regex)
extend('confirmed', confirmed)
extend('phone', {
    validate: value => {
        let strongRegex = /^\+[0-9]+$/;
        return strongRegex.test(value);
    }
})
extend('birth', {
    validate: value => {
        let delte = new Date(new Date().setFullYear(new Date().getFullYear() - 18));
        return delte > new Date(value);
    }
})
extend('length', length)
extend('confirmed', confirmed)